export default __webpack_public_path__ + "static/media/eton-college.d53912d3.svg";